import { getCmdbGlobalConfigObjectSchemaByIdPropertyUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/global.tsx';
import { getCmdbObjectSchemaByIdObjectTypesUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/object-schema.tsx';
import { getCmdbObjectTypeByIdAttributesUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/object-type.tsx';
import { getCmdbObjectByIdUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/object.tsx';
import type {
	WorkspaceId,
	SchemaId,
	CmdbObjectId,
	CmdbObjectTypeId,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';

export const getObjectDetailsUrl = (workspaceId: WorkspaceId, objectId: CmdbObjectId): string =>
	getCmdbObjectByIdUrl(workspaceId, objectId);

export const getEditableAttributeTypesUrl = (
	workspaceId: WorkspaceId,
	objectTypeId: CmdbObjectTypeId,
): string =>
	getCmdbObjectTypeByIdAttributesUrl(workspaceId, objectTypeId, { onlyValueEditable: true });

export const getObjectTypesUrl = (workspaceId: WorkspaceId, objectSchemaId: SchemaId): string =>
	getCmdbObjectSchemaByIdObjectTypesUrl(workspaceId, objectSchemaId, { excludeAbstract: true });

export const getObjectSchemaPropertyUrl = (
	workspaceId: WorkspaceId,
	objectSchemaId: SchemaId,
): string => getCmdbGlobalConfigObjectSchemaByIdPropertyUrl(workspaceId, objectSchemaId);
